<template>
  <div class="flex items-center">
    <!-- <vs-avatar :src="bank.thumbnail" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" /> -->
    <router-link v-if="bank.name" :to="url" class="text-inherit hover:text-primary" @click.stop.prevent>
      {{ bank.name }}
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    bank() {
      return this.params.value;
    },
    url() {
      return `/a/examedge/banks/${this.params.value}`;
    },
  },
};
</script>
